import React from 'react'
import Browser from '../browser'

const BrowserDe = () => {
    return <Browser languageCode="de" />
}

export default BrowserDe
